import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=aad2de7e"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports